import { render, staticRenderFns } from "./SeguridadPivotTable.vue?vue&type=template&id=1ff43c1c"
import script from "./SeguridadPivotTable.vue?vue&type=script&lang=js"
export * from "./SeguridadPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports